import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const MetaDataService = {
    getLocationMetaData,
    addMetaData,
    modifyMetaData,
    deleteMetaData
}

// retrieves the labels of the given page id
function getLocationMetaData(locationID) {
    const query = `{
        locationByID(locationID: ${JSON.stringify(locationID)})
        {
            metaData {
                id
                buildingType
                surface
                constructionYear
                isLowConsumption
                nbInhabitants
                hasConvertedAttic
                hasMultipleFloors
                hasVeranda
                isTerracedHouse
                ceilingHeight
                hasPool
                temperature
                reduceHeatingWhenAbsent
                alwaysSomeoneAtHome
                useLowConsumptionBulbs
                useAirConditioner
            }
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.locationByID);
    })
}

function addMetaData(locationID, {
        buildingType,
        surface,
        constructionYear,
        isLowConsumption,
        nbInhabitants,
        hasConvertedAttic,
        hasMultipleFloors,
        hasVeranda,
        isTerracedHouse,
        ceilingHeight,
        hasPool,
        temperature,
        reduceHeatingWhenAbsent,
        alwaysSomeoneAtHome,
        useLowConsumptionBulbs,
        useAirConditioner
    }) {
    const query = `mutation{
        addMetaData(
            locationID: ${JSON.stringify(locationID)},
            buildingType: ${JSON.stringify(buildingType)},
            surface: ${surface ? surface : null},
            constructionYear: ${constructionYear ? constructionYear : null},
            isLowConsumption: ${isLowConsumption},
            nbInhabitants: ${nbInhabitants ? nbInhabitants : null},
            hasConvertedAttic: ${hasConvertedAttic},
            hasMultipleFloors: ${hasMultipleFloors},
            hasVeranda: ${hasVeranda},
            isTerracedHouse: ${isTerracedHouse},
            ceilingHeight: ${ceilingHeight ? ceilingHeight : null},
            hasPool: ${hasPool},
            temperature: ${temperature ? temperature : null},
            reduceHeatingWhenAbsent: ${reduceHeatingWhenAbsent},
            alwaysSomeoneAtHome: ${alwaysSomeoneAtHome},
            useLowConsumptionBulbs: ${useLowConsumptionBulbs},
            useAirConditioner: ${useAirConditioner}
        )
            {
                id
            }
        }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
      }
      return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
            return handleHttpResponse(response)
            .then(data => data.addMetaData);
        })
}

function modifyMetaData(metaDataID,
{
    buildingType,
    surface,
    constructionYear,
    isLowConsumption,
    nbInhabitants,
    hasConvertedAttic,
    hasMultipleFloors,
    hasVeranda,
    isTerracedHouse,
    ceilingHeight,
    hasPool,
    temperature,
    reduceHeatingWhenAbsent,
    alwaysSomeoneAtHome,
    useLowConsumptionBulbs,
    useAirConditioner
}) {
const query = `mutation{
    modifyMetaData(
        metaDataID: ${JSON.stringify(metaDataID)},
        buildingType: ${JSON.stringify(buildingType)},
        surface: ${surface ? surface : null},
        constructionYear: ${constructionYear ? constructionYear : null},
        isLowConsumption: ${isLowConsumption},
        nbInhabitants: ${nbInhabitants ? nbInhabitants : null},
        hasConvertedAttic: ${hasConvertedAttic},
        hasMultipleFloors: ${hasMultipleFloors},
        hasVeranda: ${hasVeranda},
        isTerracedHouse: ${isTerracedHouse},
        ceilingHeight: ${ceilingHeight ? ceilingHeight : null},
        hasPool: ${hasPool},
        temperature: ${temperature ? temperature : null},
        reduceHeatingWhenAbsent: ${reduceHeatingWhenAbsent},
        alwaysSomeoneAtHome: ${alwaysSomeoneAtHome},
        useLowConsumptionBulbs: ${useLowConsumptionBulbs},
        useAirConditioner: ${useAirConditioner}
    )
        {
            id
        }
    }`;
const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.modifyMetaData);
    })
}

function deleteMetaData(metaDataID, locationID) {
    const query = `mutation{
        deleteMetaData(
            metaDataID: ${JSON.stringify(metaDataID)},
            locationID: ${JSON.stringify(locationID)},
        )
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => {
            return data.deleteMetaData;
        });
      })
}